import { useTranslation } from 'react-i18next';
import { formatOrderTotal, getOrderSummaryTotals } from '~/utils';
import type { OrderSummaryItem } from '~/utils';
import type { OrderStatus } from '~/graphql/graphql';

export function OrderSummaryCard({
  items,
  status,
  currency: orderCurrency,
  incoTerm,
}: {
  items: OrderSummaryItem[];
  status: OrderStatus;
  currency?: string | null;
  incoTerm?: string | null;
}) {
  const { t } = useTranslation('order');

  const { listedTotal, suggestedTotal, currency, shouldShowSuggestedTotal } =
    getOrderSummaryTotals(items, status, orderCurrency, incoTerm);

  return (
    <div className="bg-neut-light rounded-lg border border-gray-200 p-6 shadow-sm">
      <h2 className="text-neutral-900 font-semibold mb-4">
        {t('order.order_summary')}
      </h2>
      <div className="space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">{t('order.item_total')}</span>
          <span className="text-neutral-900 font-medium">
            {formatOrderTotal(listedTotal, t('order.not_available'), currency)}
          </span>
        </div>
        <div className="border-t border-gray-200 pt-3 flex items-center justify-between">
          <span className="text-neutral-900 font-semibold">
            {t('order.total_amount')}
          </span>
          <span className="text-xl text-neutral-900 font-semibold">
            {formatOrderTotal(listedTotal, t('order.not_available'), currency)}
          </span>
        </div>
        {shouldShowSuggestedTotal && (
          <div className="flex items-center justify-between">
            <span className="text-neutral-900 font-semibold">
              {t('order.suggested_total')}
            </span>
            <span className="text-xl text-warning-700 font-semibold">
              {formatOrderTotal(
                suggestedTotal,
                t('order.not_available'),
                currency
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
